import {FIX_VERSION, PATCH_VERSION} from './patch-version-consts';

export const DISPATCHER_PREFIX = '/rest';

export const MS_REQUEST_TIMEOUT = 1000;

export const USER_GUIDE_LINK = `https://mexos-docs.s3-eu-west-1.amazonaws.com/Mexos+BO+guide+${PATCH_VERSION + '.' + FIX_VERSION}.pdf`;

export const RELEASE_NOTES_LINK = `https://mexos-docs.s3-eu-west-1.amazonaws.com/Mexos+Release+Notes+${PATCH_VERSION + '.' + FIX_VERSION}.pdf`;

export const INFORMATION_TOOLTIP_LINK = `assets/information-tooltip+${PATCH_VERSION + '.' + FIX_VERSION}.json`;

export const FAQ_LINK = `assets/faq+${PATCH_VERSION + '.' + FIX_VERSION}.json`;

export const DEAL_API_LINK = `assets/deal_api+${PATCH_VERSION + '.' + FIX_VERSION}.json`;

export const TRIGGER_FRONTENT = `assets/deal_api+${PATCH_VERSION + '.' + FIX_VERSION}.json`;
